// Thin guard around GA4's global gtag so the planner never crashes if the
// script is blocked (ad-blocker) or absent (dev). No state, nothing to maintain.
export function track(name: string, params: Record<string, unknown> = {}): void {
  (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag?.('event', name, params);
}
